const generateAction = (type, payload) => ({
  type,
  payload,
})

export default generateAction
